module.exports = __webpack_public_path__ + "img/defaultMan.96c20fe6.jpg";